import { TERMINAL } from '@/constants/cms';
import { jdiColorFetch } from './colorFetchV2';
import { CMSPageResponse } from './types/cms';

// 获取cms c端的真实数据
export const getCmsPageRealData = async (pageCode: string) => {
  const response = await jdiColorFetch('guide_homepage_getPageAllData', {
    method: 'POST',
    // cache: "no-store",
    headers: {
      // "Cache-Control": "no-cache",
    },
    bodyQuery: {
      pageCode,
      pageType: 1,
      tenantCode: '__default__',
      businessType: 2,
      terminal: TERMINAL.PC,
      shopId: -1,
      systemType: 1,
    },
    next: {
      revalidate: 10,
    },
  });

  return response;
};

// 获取cms 运营端的预览数据
export const getCmsPreviewData = async (pageId: number, pageCode: string) => {
  const response = await jdiColorFetch('guide_homepage_preview', {
    method: 'POST',
    // cache: "no-store",
    headers: {
      // "Cache-Control": "no-cache",
    },
    bodyQuery: {
      pageCode,
      pageType: 1,
      tenantCode: '__default__',
      businessType: 2,
      terminal: TERMINAL.PC,
      shopId: -1,
      systemType: 1,
      terminalRootType: 2,
      pageId,
    },
    next: {
      revalidate: 10,
    },
  });
  return response;
};

export const getCmsPageData = async (
  pageCode: string,
  preview = false,
  pageId?: number,
  previewTime?: string,
): Promise<CMSPageResponse> => {
  let pageData: any = {};
  if (preview && pageId && previewTime) {
    pageData = await getCmsPreviewData(pageId, pageCode);
  } else {
    if (pageCode) {
      pageData = await getCmsPageRealData(pageCode);
    }
  }
  return pageData;
};
